import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";
import Modal from "../../components/Modal";
import "./style.scss";
import Checkbox from "../../elements/checkbox";
import RadioButtonGroup from "../../elements/radio-button-group";
import Input from "../../elements/input";
import InputPhoneNumber from "../../elements/InputPhoneNumber";
import BodyText from "../../elements/body-text";
import { isEmptyObj } from "../../utils/siteUtils";
import getSiteInfo from "../../utils/getSiteInfo";

export default function NotifyMeModal(props) {
  const {
    headingType,
    headingBody,
    subHeadingType,
    subHeadingBody,
    submitCTA,
    termsCheckboxLabel,
    termsCheckboxConsent,
    showModal,
    setShowModal,
    options,
    emailLabel,
    emailWarningMessage,
    emailMissingMessage,
    phoneAreaLabel,
    phoneLabel,
    phoneMissingMessage,
    phoneWarningMessage,
    requiredError,
    requiredSuccess,
    notifyError,
    notifySuccess,
    callback
  } = props;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState({});
  const [optionsProp, setOptionsProp] = useState([]);
  const [formDataEmail, setEmail] = useState();
  const [formDataPhoneArea, setPhoneArea] = useState();
  const [phoneIsValid, setPhoneIsValid] = useState(true);
  const [submitTimestamp, setSubmitTimestamp] = useState();
  const [formDataPhone, setPhone] = useState();
  const [formDataAgreedToTerms, setAgreeToTerms] = useState();
  const [emailHasError, setEmailHasError] = useState();
  const [agreedToTermsHasError, setAgreedToTermsHasError] = useState();
  const [emailHasValidationError, setEmailHasValidationError] = useState();
  const inputProp = [
    {
      label: emailLabel?.value,
      type: "email"
    },
    {
      label: emailLabel?.value,
      type: "email"
    }
  ];
  useEffect(() => {
    let newArr = [];
    (options || []).forEach(data => {
      let item = { ...data?.fields, label: data?.fields.label?.value, value: data?.fields.label?.value };
      newArr.push(item);
      if (data?.fields.checked.value) {
        setSelectedOption(item);
      }
    });
    setOptionsProp(newArr);
  }, [options]);
  const RadioButtonGroupProp = {
    selectedOption: isEmptyObj(selectedOption) ? optionsProp[0] : selectedOption,
    options: optionsProp
  };
  const getRadioButtonIndex = data => {
    var selectedOption = RadioButtonGroupProp.options.findIndex(option => option.value === data.value);
    setSelectedIndex(selectedOption);
    setSelectedOption(data);
    setEmail("");
    setPhoneArea("");
    setPhone("");
  };
  const onEmailChange = (evt, isValid) => {
    setEmail(evt.target.value);
    if (evt.target.value) {
      setEmailHasValidationError(!isValid);
    } else {
      setEmailHasValidationError(false);
    }
  };
  const onPhoneChange = (area, number, isValid) => {
    setPhoneArea(area);
    setPhone(number);
    setPhoneIsValid(isValid);
  };
  const termsCheckboxChange = checked => {
    setAgreeToTerms(checked);
    setAgreedToTermsHasError(false);
  };
  const onEmailHasFocus = () => {
    setEmailHasError(false);
  };

  const dataIsValidToSubmit = () => {
    return (!emailHasError && !emailHasValidationError && formDataAgreedToTerms) || (phoneIsValid && formDataAgreedToTerms);
  };
  const onSubmit = async evt => {
    setSubmitTimestamp(new Date());
    evt.preventDefault();
    let isEmail = selectedOption?.code?.value === "email";
    const termsAndConditionNos = termsCheckboxConsent.map(t => t.id);
    const { country } = await getSiteInfo();
    const formData = {
      noticeType: isEmail ? "NOTICETYPE001" : "NOTICETYPE002",
      email: formDataEmail,
      mobileCountryCode: formDataPhoneArea,
      mobileNo: formDataPhone,
      agreedToTerms: formDataAgreedToTerms,
      consentNos: [...termsAndConditionNos],
      country
    };
    if (!formDataEmail && isEmail) {
      setEmailHasError(true);
    }
    if (!formDataAgreedToTerms) {
      setAgreedToTermsHasError(true);
    }
    let isValid = dataIsValidToSubmit();
    if (isValid) {
      callback(evt, formData);
    } else {
      evt.target.focus();
    }
  };
  return (
    <Modal
      className="notify-me-modal"
      showModal={showModal}
      onCloseClicked={() => {
        setShowModal(false);
      }}
    >
      <div className="notify-me-modal-heading">
        <Heading
          {...{
            type: headingType || { fields: { phrase: { value: "h1" } } },
            html: headingBody
          }}
          typographyClass="type-h1"
        />
      </div>
      <div className="notify-me-modal-sub-heading">
        <Heading
          {...{
            type: subHeadingType || { fields: { phrase: { value: "h3" } } },
            html: subHeadingBody
          }}
          typographyClass="type-h4"
        />
      </div>
      <div className="notify-me-modal-radio-buttons">
        <RadioButtonGroup {...RadioButtonGroupProp} horizontal={true} onChange={data => getRadioButtonIndex(data)} />
      </div>
      <div className="notify-me-modal-email">
        {selectedOption?.code?.value === "email" && (
          <Input
            {...{
              autocomplete: "email",
              name: "email",
              label: emailLabel.value,
              value: formDataEmail,
              warningMessage: emailHasValidationError ? emailWarningMessage.value : emailMissingMessage.value,
              type: "email",
              showError: emailHasError,
              onChange: (evt, isValid) => onEmailChange(evt, isValid),
              onFocus: onEmailHasFocus
            }}
          />
        )}
        {selectedOption?.code?.value === "sms" && (
          <>
            <InputPhoneNumber
              phoneArea={{
                label: phoneAreaLabel.value,
                value: formDataPhoneArea
              }}
              phoneNumber={{
                label: phoneLabel.value,
                value: formDataPhone
              }}
              onInit={(area, number, isValid) => onPhoneChange(area, number, isValid)}
              onChange={(area, number, isValid) => onPhoneChange(area, number, isValid)}
              warningMessage={phoneWarningMessage.value}
              missingMessage={phoneMissingMessage.value}
              submitTimestamp={submitTimestamp}
            />
          </>
        )}
      </div>
      {termsCheckboxLabel && (
        <div className="notify-me-modal-checkbox">
          <Checkbox
            {...{
              label: termsCheckboxLabel?.value,
              error: agreedToTermsHasError,
              checked: formDataAgreedToTerms,
              onChange: termsCheckboxChange
            }}
          />
        </div>
      )}
      <div className="notify-me-modal-message">
        {notifyError && <BodyText className={"failed-message"} html={requiredError} />}
        {notifySuccess && <BodyText className={"success-message"} html={requiredSuccess} />}
      </div>
      <div className="notify-me-modal-button">
        <PrimaryButton
          {...{
            ...submitCTA?.fields,
            buttonText: submitCTA?.fields?.buttonText?.value,
            callback: evt => onSubmit(evt)
          }}
          id="send-request-button"
        />
      </div>
    </Modal>
  );
}

NotifyMeModal.propTypes = {
  heading: PropTypes.shape({
    type: PropTypes.string,
    className: PropTypes.string,
    /** This takes the component is RTF */
    html: PropTypes.string
  }),
  subheading: PropTypes.shape({
    type: PropTypes.string,
    className: PropTypes.string,
    /** This takes the component is RTF */
    html: PropTypes.string
  }),
  termsCheckbox: PropTypes.object,
  button: PropTypes.shape({
    callback: PropTypes.func,
    icon: PropTypes.shape({ svg: PropTypes.string }),
    colorScheme: PropTypes.string,
    width: PropTypes.string,
    isDisabled: PropTypes.bool,
    internalLink: PropTypes.any,
    transition: PropTypes.any,
    buttonText: PropTypes.string
  }),
  input: PropTypes.shape({
    pattern: PropTypes.string,
    infoMessage: PropTypes.string,
    warningMessage: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.oneOf(["email", "password", "dateOfBirth", "tel"]),
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onHasValidationError: PropTypes.func,
    hasError: PropTypes.bool,
    showError: PropTypes.bool,
    className: PropTypes.string,
    name: PropTypes.string,
    shouldValidate: PropTypes.bool
  })
};
